// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource-search__multiselect[data-v-cb35b75c]{padding-bottom:5px !important}", "",{"version":3,"sources":["webpack://./src/components/Editor/Resources/ResourceListSearch.vue"],"names":[],"mappings":"AACA,+CACC,6BAAA","sourcesContent":["\n.resource-search__multiselect {\n\tpadding-bottom: 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
